<template>
  <div class="ParticlesText">
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script>
import Proton from 'proton-js'

export default {
  name: 'ParticlesText',
  beforeDestroy() {
    this.$renderer.gl.getExtension('WEBGL_lose_context').loseContext()
    this.$proton.destroy()
    this.untick()
  },
  activated() {
    this.tick()
  },
  deactivated() {
    this.untick()
  },
  mounted() {
    const canvas = this.$refs.canvas
          canvas.width = 820
          canvas.height = 180
    this.$canvas = canvas
    this.createProton(canvas)
    this.createRenderer(canvas)
  },
  methods: {
    createProton(canvas) {
      const proton = new Proton
      const emitter = new Proton.Emitter()
      this.$crossZoneBehaviour = new Proton.CrossZone(new Proton.RectZone(100, 20, 620, 90), 'bound')
      emitter.damping = 0.008
      emitter.rate = new Proton.Rate(new Proton.Span(100))
      emitter.addInitialize(new Proton.Body(require('./images/smoke1.png'), 128, 128))
      emitter.addInitialize(new Proton.Velocity(new Proton.Span(1.8), new Proton.Span(0, 360), 'polar'))
      emitter.addBehaviour(new Proton.Alpha(1), new Proton.Color('#20CE98'));
      emitter.addBehaviour(new Proton.Scale(Proton.getSpan(0.50, 1)));
      emitter.addBehaviour(this.customBehaviour())
      emitter.addBehaviour(this.$crossZoneBehaviour)
      emitter.emit('once')
      proton.addEmitter(emitter)
      this.$emitter = emitter
      this.$proton = proton
    },
    createRenderer(canvas) {
      const renderer = new Proton.WebGLRenderer(canvas)
            renderer.blendFunc("SRC_ALPHA", "ONE")
      this.$renderer = renderer
      this.$proton.addRenderer(renderer)
    },
    customBehaviour(visage) {
      let index = 0
      return {
        initialize: function(particle) {
          particle.p.x = _.random(620) + 100
          particle.p.y = 0
          particle.ref = index
          particle.sens = 'r'
          particle.dist = (particle.ref%4 == 0) ? _.random(0.25, 1.8) : 0.1
          particle.dx = 0
          particle.vt = 't'
          particle.vd = (particle.ref%3 == 0) ? _.random(0.40, 1) : 0.05
          particle.dy = 0
          particle.spx = _.random(25, 150)
          particle.spy = _.random(25, 200)

          // particle.transform.rgb.r = 37
          // particle.transform.rgb.g = 138
          // particle.transform.rgb.b = 214

          particle.transform.rgb.r = 219
          particle.transform.rgb.g = 219
          particle.transform.rgb.b = 22

          index +=1
        },
        applyBehaviour: function(particle) {
          if(particle.ref%3 == 0){

            particle.transform.rgb.r = 219
            particle.transform.rgb.g = 219
            particle.transform.rgb.b = 22


            // particle.transform.rgb.r = 32
            // particle.transform.rgb.g = 206
            // particle.transform.rgb.b = 152


          }
          particle.dx = (particle.sens == 'r') ? particle.dx + particle.dist : particle.dx - particle.dist
          if(particle.dx > particle.spx) {
            particle.sens = 'l'
            particle.dx = 0
          } else if(particle.dx < -particle.spx) {
            particle.sens = 'r'
            particle.dx = 0
          }
          particle.p.x += (particle.sens == 'r') ? particle.dist : -particle.dist
          particle.dy = (particle.vt == 't') ? particle.dy + particle.dist : particle.dy - particle.dist
          if(particle.dy > particle.spy) {
            particle.vt = 'b'
            particle.dy = 0
          } else if(particle.dy < -particle.spy) {
            particle.vt = 't'
            particle.dy = 0
          }
          particle.p.x += (particle.vt == 't') ? particle.dist : -particle.dist
        }
      }
    },
    tick() {
      this.$rafID = requestAnimationFrame(this.tick)
      this.$proton.update()
    },
    untick() {
      if(this.$rafID)
        cancelAnimationFrame(this.$rafID)
    }
  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.ParticlesText
  position fixed
  left 50%
  transform translate(-50%)
  right 0px
  bottom -30px
  width 820px
  height 180px
  filter blur(10px)

  canvas
    position absolute
    width 100%
    height 100%
    opacity .4
</style>



// WEBPACK FOOTER //
// src/components/particles/ParticlesText.vue